import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import BoxContainer from '../../style-components/BoxContainer.jsx';
import LearnUnitsTable from '../../style-components/Tables/LearnUnitsTable.jsx';
import { getCurrentUser } from '../../models/user.js';

const LearnUnitsListAll = () => {
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentUser()
      .then(user => {
        if (user.role !== 'ADMIN') {
          navigate('/unauthorized');
        }
      })
      .catch();
  }, []);

  return (
    <BoxContainer>
      <LearnUnitsTable />
    </BoxContainer>
  );
};

export default LearnUnitsListAll;
